module.exports = __webpack_public_path__ + "static/media/ProximaNova-ExtrabldIt.45a35c62.woff";